var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlu41(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3319_10343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8037 25.1965L36.3268 7.65799C36.3268 7.65799 40.5548 3.56095 44.259 7.2651L54.0618 23.8869",
    stroke: "black",
    strokeWidth: 5.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6602 39.75V37.6187L36.0039 29.2H37.8414V32.15H36.7539L33.3852 37.4812V37.5812H40.9789V39.75H30.6602ZM36.8039 42V39.1L36.8539 38.1562V29.2H39.3914V42H36.8039ZM48.1789 29.2V42H45.4727V31.7687H45.3977L42.4664 33.6062V31.2062L45.6352 29.2H48.1789Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8234 78H22.9234L27.3422 65.2H30.8297L35.2422 78H32.3422L29.1359 68.125H29.0359L25.8234 78ZM25.6422 72.9687H32.4922V75.0812H25.6422V72.9687ZM36.7828 78V65.2H39.4891V75.7687H44.9766V78H36.7828ZM54.675 65.2H57.3813V73.5125C57.3813 74.4458 57.1583 75.2625 56.7125 75.9625C56.2708 76.6625 55.6521 77.2083 54.8563 77.6C54.0604 77.9875 53.1333 78.1813 52.075 78.1813C51.0125 78.1813 50.0833 77.9875 49.2875 77.6C48.4917 77.2083 47.8729 76.6625 47.4313 75.9625C46.9896 75.2625 46.7688 74.4458 46.7688 73.5125V65.2H49.475V73.2812C49.475 73.7687 49.5813 74.2021 49.7938 74.5812C50.0104 74.9604 50.3146 75.2583 50.7063 75.475C51.0979 75.6917 51.5542 75.8 52.075 75.8C52.6 75.8 53.0563 75.6917 53.4438 75.475C53.8354 75.2583 54.1375 74.9604 54.35 74.5812C54.5667 74.2021 54.675 73.7687 54.675 73.2812V65.2Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2564 55.9971L16.8061 55.6531C16.8061 55.6531 11.1439 54.04 12.4997 48.9801L21.9932 32.1797",
    stroke: "black",
    strokeWidth: 5.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2048 30.6758L68.1321 48.5583C68.1321 48.5583 69.5662 54.2684 64.5063 55.6242L45.21 55.8028",
    stroke: "black",
    strokeWidth: 5.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3418 55.8543L49.0777 48.9414V62.5529L37.3418 55.8543Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3027 32.2137L26.0387 25.3008V38.9123L14.3027 32.2137Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3223 23.9872L58.0582 17.0742V30.6857L46.3223 23.9872Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3319_10343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlu41);
export default __webpack_public_path__ + "static/media/alu41.e964633fd43b20fc3527a9831d1ad817.svg";
export { ForwardRef as ReactComponent };